module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product23-49970cbe1c3af9922a22845b76fd633e.jpg";